import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import {
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
  Stack,
} from '@mui/material';

const CreateAccountPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const createAccount = async () => {
    setError('');
    setIsSubmitting(true);

    if (password !== confirmPassword) {
      setError('Password and confirm password do not match');
      setIsSubmitting(false);
      return;
    }

    try {
      const auth = getAuth();
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);

      // Optional: send to your backend
      // const headers = {
      //   'Content-Type': 'application/json',
      //   Authorization: `Bearer ${userCredential._tokenResponse.idToken}`,
      // };
      // const data = {
      //   FirebaseUid: userCredential.user.uid,
      //   Email: userCredential.user.email,
      //   Organization: "OCPW Survey",
      // };
      // await axios.post('/api/user', data, { headers });

      navigate('/tools');
    } catch (e) {
      setError(e.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Create Account
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Stack spacing={2}>
          <TextField
            label="Email Address"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <TextField
            label="Password"
            type="password"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <TextField
            label="Confirm Password"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />

          <Button
            variant="contained"
            color="primary"
            onClick={createAccount}
            fullWidth
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Creating...' : 'Create Account'}
          </Button>

          <Button component={Link} to="/login" variant="text">
            Already have an account? Log in here
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default CreateAccountPage;
